
class NetworkConstants {

  everyoneEmailAddress = '*';

}

export default new NetworkConstants();